<template>
  <div class="bscroll" ref="bscroll">
    <div class="bscroll-container" >
      <div @click="scrollNavClick(item,$event)" class="link-item" v-for="(item, index) in list" :key="index" :class="{active: item[cusValue] == activeIndex}">{{item[cusKey]}}</div>
    </div>
  </div>
</template>

<script> 
//导入包
import BScroll from "better-scroll";

export default {
  data() {
    return {
      
    }
  },
  props: ['activeIndex','list','cusKey','cusValue'],
  mounted(){
    this.initBScroll();
  },
  methods: {
    initBScroll() {
      this.$nextTick(() => {
        if(this.aBScroll) return;
        let bscrollDom = this.$refs.bscroll;
        this.aBScroll = new BScroll(bscrollDom,{
          scrollX: true,
          click: true,
          useTransition:false,
        })
        this.scroll(document.querySelector('.link-item.active'))
      })
    },
    scrollNavClick(item,e) {
      this.$emit('scrollNavClick', item);
      this.scroll(e.target)
    },
    // 判断当前点击的元素的位置，自动滚动
    scroll(el) {
      this.aBScroll.scrollToElement(el,500, true, true)
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../../assets/css/register.scss';
@import '../../assets/css/base.scss';
  .bscroll {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    background-color: rgba(255,255,255,.6);
    text-align: center;
    &-container {
      white-space:nowrap;
      display: inline-block;
      // width: 945px;
      // margin: 0 auto;
      .link-item {
        display: inline-block;
        color: #222;
        padding: 15px 38px;
        font-size: 14px;
        cursor: pointer;
        transition: all .5s;
        &.active {
          background-color: rgba(255,0,0,.8);
          color: #fff;
        }
        &:hover {
          background-color: rgba(255,0,0,.8);
          color: #fff;
        }
      }
    }
  }
  @media screen and(max-width: 992px) {
    .bscroll {
      &-container {
        // width: 750px;
        .link-item {
          padding: 10px 24px;
        }
      }
    }
  }
  @media screen and(max-width: 768px) {
    .bscroll {
      &-container {
        .link-item {
          &:hover {
            background-color: transparent;
            color: #000;
          }        
          &.active {
            background-color: rgba(255,0,0,.8);
            color: #fff;
          }
        }
      }
    }
  }
  //   .bscroll {
  //     &-container {
  //       width: 750px;
  //       li {
  //         padding: 10px 20px;
  //       }
  //     }
  //   }
  // }
</style>